import { UserEntityAssignmentBase } from "./userEntityAssignment";

export enum UserIncomeType {
    INDIVIDUAL = "individual",
    BUSINESS = "business",
    EMPLOYEE = "employee",
    REAL_ESTATE = "real_estate",
}

export enum UserType {
    REGULAR = "regular",
    SUPPORT = "support",
    DEMO = "demo", // user who can log in
    DEMO_FAKE = "demo_fake", // users created in DB for demo account, but not able to log in
}

export enum UserSignupPurpose {
    BUSINESS_OWNER = "business_owner",
    ACCOUNTANT = "accountant",
}

export const VISIBLE_USER_TYPES: UserType[] = [
    UserType.REGULAR,
    UserType.DEMO,
    UserType.DEMO_FAKE,
] as const;

export interface UserEventsTriggered {
    initialCategorizationCompleted?: boolean;
    categorizationAfterSubscriptionCompleted?: boolean;
    emailVerified?: boolean;
    applicationSubmitted?: boolean;
}

/**
 * Base type for User - allows undefined on relations.
 * Used by entity classes (TypeORM).
 */
export interface UserBase {
    id: number;
    name: string;
    legalName: string | null;
    preferredName: string | null;
    email: string | null;
    avatar: string | null;
    firstName: string;
    lastName: string;
    phoneNumber: string | null;
    unverifiedPhoneNumber: string | null;
    phoneNumberDisplay: string | null;
    dateOfBirth: Date | null;
    incomeType: UserIncomeType[];
    onboardingComplete: boolean;
    showBookkeepingReviewInvite: boolean;
    bookkeepingReviewScheduled: boolean;
    entityAssignments?: UserEntityAssignmentBase[];
    lastActivity: Date;
    iconColor: string;
    savingsCreditLimit: number;
    freeUsageLimit: number;
    settings: UserSettings;
    createdAt: Date;
    onboardingCompletedAt: Date | null;
    eventsTriggered: UserEventsTriggered | null;
    stripeCustomerId: string | null;
    productTips?: UserProductTips | null;
    bookedEnterpriseCall: boolean;
    type: UserType;
    signupPurpose: UserSignupPurpose | null;
}

export type User = UserBase;

export interface UserSettings {
    weeklyInsightsEnabledAt: string | null;
    monthlyInsightsEnabledAt: string | null;
    dailyTasksDigestEnabledAt: string | null;
}

export interface PartnerStackData {
    xid: string;
    partnerKey?: string;
}

export interface DubPartnersData {
    dubId: string;
    clickId?: string;
    eventId?: string;
    leadTrackedAt?: string;
    saleTrackedAt?: string;
}

export interface UserProductTips {
    initialProductTipTransactions?: string;
    initialProductTipInvoices?: string;
}

export interface UserMetadata {
    bookkeepingStartDateBackup: Date;
    autoMarkBlockedTaskAsDoneAt?: string | null;
    firstTouch?: object;
    lastTouch?: object;
    plainCustomerId?: string;
    plainCompanyId?: string | null;
    plainTenantId?: string;
}
